import React from 'react';

// Streamline Ultimate Light — Monitor Chart
// https://www.streamlinehq.com/icons/download/monitor-chart--8348 (ico_mRu4pQJ4vWzO2aEYBGdzp35e)
export const IconPricingOverview: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="44" height="44" fill="none" className="shrink-0 text-[#d9cdc5]">
        <path
            d="M9 13c2.4853 0 4.5 -2.0147 4.5 -4.5C13.5 6.01472 11.4853 4 9 4 6.51472 4 4.5 6.01472 4.5 8.5 4.5 10.9853 6.51472 13 9 13"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M9 4v4.5l3.182 3.182M16.5 5.5h3M16.5 8.5h3M16.5 11.5h3"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M15.001 23.25H9.00098l0.75 -4H14.251zM7.25098 23.25H16.751M0.75 16.25h22.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M0.75 2.75c0 -1.10457 0.89543 -2 2 -2h18.5c1.1046 0 2 0.89543 2 2v14.5c0 1.1046 -0.8954 2 -2 2H2.75c-1.10457 0 -2 -0.8954 -2 -2z"
            stroke="currentColor"
            strokeWidth="1"
        />
    </svg>
);

// Streamline Ultimate Light — Target Correct
// https://www.streamlinehq.com/icons/download/target-correct--8364 (ico_mRu4pQJ4vIvQ2aEHO2htdxhU)
export const IconPricingAnalysis: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="44" height="44" fill="none" className="shrink-0 text-[#d9cdc5]">
        <path
            d="m9.5 11.5 5 -5M14.793 3.207a1 1 0 0 0 -0.293 0.707V6.5h2.586a1 1 0 0 0 0.707 -0.293L20.5 3.5h-3v-3Z"
            fill="none"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M9.5 16.5a5 5 0 1 1 4.771 -6.5M9.5 20.5A9 9 0 1 1 12.464 3"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M11.5 17.5a6 6 0 1 0 12 0 6 6 0 1 0 -12 0ZM20.174 15.756l-2.905 3.873a0.752 0.752 0 0 1 -1.131 0.081l-1.5 -1.5"
            fill="none"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
    </svg>
);

// Streamline Ultimate Light — Workflow Report Document
// https://www.streamlinehq.com/icons/download/workflow-report-document--8382 (ico_DJUVsnjs31ShmBPn)
export const IconPricingRecords: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="44" height="44" fill="none" className="shrink-0 text-[#d9cdc5]">
        <path
            d="M12.5 14.5a1 1 0 0 1 -1 1H1.247a0.75 0.75 0 0 1 -0.75 -0.75V3.25a0.75 0.75 0 0 1 0.75 -0.75h10.5a0.75 0.75 0 0 1 0.75 0.75ZM3.497 4l0 -3.5M6.497 4l0 -3.5M9.497 4l0 -3.5M7.497 6.5l-4 0M8.497 9.5l-5 0M9.497 12.5l-6 0"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="M19.5 10.5V6a2 2 0 0 0 -2 -2h-2M16.997 8l2.5 2.5 2.5 -2.5M16.262 14.614a5.4 5.4 0 0 0 6 1.207M15.804 16.254a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0ZM23.5 23.5a5.368 5.368 0 0 0 -9 0"
            fill="none"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
    </svg>
);

// Streamline Ultimate Light — API Related Authentication Plug
// https://www.streamlinehq.com/icons/download/api-related-authentication-plug--26256 (ico_M4BcIk91R1eg3tH0)
export const IconPricingConnections: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="44" height="44" fill="none" className="shrink-0 text-[#d9cdc5]">
        <path
            d="M8.39063 15.8789c-4.09404 0 -7.32618 -3.2321 -7.32618 -7.32617 0 -4.09403 3.33988 -7.32617 7.32618 -7.32617 3.55537 0 6.46427 2.58571 7.11067 5.92558 0.7542 -0.53869 1.7238 -0.8619 2.6935 -0.8619 2.5857 0 4.7404 2.15476 4.7404 4.74046 0 1.1984 -0.4628 2.3274 -1.217 3.1939"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1"
        />
        <path
            d="M19.6357 18.5055c0 2.3571 -1.9108 4.2679 -4.2679 4.2679l-0.6723 0c-0.4548 0 -0.8234 -0.3686 -0.8234 -0.8233l0 -6.8892c0 -0.4547 0.3686 -0.8234 0.8234 -0.8234l0.6723 0c2.3571 0 4.2679 1.9108 4.2679 4.268Z"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            d="m11.1367 16.5156 2.7353 0M19.6357 18.5h3.2998M11.1367 20.4922l2.7353 0"
            stroke="var(--pricing-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeWidth="1"
        />
    </svg>
);
